import { Outlet } from "react-router-dom";

export default function ManageWebsite() {
    return (
        <div className="flex flex-column h-full overflow-hidden">
            <Outlet />
        </div>
    );
}
